<template>
    <div class="login-page">
        <app-navbar></app-navbar>
        <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <div class="content">
            <div class="container">
                <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                    <form @submit.prevent="passwordReset">
                        <card type="login">
                        <h3 slot="header" class="header text-center mb-2">Password Reset</h3>

                        <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25"
                            placeholder="New Password" v-validate="'required|min:3'" name="password"></fg-input>
					    <span class="text-danger">{{ errors.first('password') }}</span>

                        <fg-input v-model="form.password_confirmation" addon-left-icon="nc-icon nc-key-25" placeholder="Confirm Your New Password"
                            type="password" v-validate="'required|confirmed:password'" name="password Confirmation"></fg-input>
					    <span class="text-danger">{{ errors.first('password_confirmation') }}</span>

                        <p-button native-type="submit" type="primary" round block class="my-4">Reset</p-button>

                        <router-link class="d-block text-center" to="/login">Click Here to login</router-link>
                        </card>
                        <input v-model="form.email" v-validate="'required|email'" name="email" type="hidden">
                        <input v-model="form.token" v-validate="'required'" name="token" type="hidden">
                    </form>
                </div>
            </div>
            </div>
            <app-footer></app-footer>
            <div class="full-page-background" style="background-image: url(/static/img/background/background-2.jpg) "></div>
        </div>
        </div>
    </div>
</template>
<script>
import { Card, Checkbox, Button } from 'src/components/UIComponents';
import AppNavbar from './Layout/AppNavbar'
import AppFooter from './Layout/AppFooter'
import swal from 'sweetalert2'
import client from '@/util/client'

export default {
    components: {
        Card,
        AppNavbar,
        AppFooter,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button,
    },
    methods: {
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        passwordReset() {
            const vm = this
            this.$validator.validate().then( async valid => {
                if (!valid) {
                    return false
                } else {
                    await client.patch('/users/user/password/reset', {
                        "email": vm.form.email,
                        "password": vm.form.password,
                        "password_confirmation": vm.form.password_confirmation,
                        "token": vm.form.token
                    }).then(res => {
                        vm.$store.dispatch('auth/login', {
							email: vm.form.email,
							password: vm.form.password
						})
                        .then(() => {
                            vm.$store.dispatch('auth/fetchUser')
                            .then (() => {
                                this.$router.push({ path: '/'})
                            })
                        })
                    }).catch(e => {
                        swal({
                            title: `There was a problem, please try again.`,
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-primary btn-fill'
                        })
                    })
                }
            })
        }
    },
    data() {
        return {
            form: {
                email: '',
                password: '',
                password_confirmation: '',
                token: '',
            },
        }
    },
    created() {
        if(typeof this.$route.query.email == undefined || this.$route.query.email == null || typeof this.$route.query.token == undefined || this.$route.query.token == null) {
            this.$router.push('password-reset')
        }
    },
    beforeDestroy() {
        this.closeMenu()
    }
}
</script>
<style>
</style>
